// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_95-4";
export var collapsed = "_95-1";
export var headerBar = "_95-0";
export var leftHeaderContent = "_95-3";
export var subjectContainer = "_95-2";